import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorPageComponent } from './ctp/error-page/error-page.component';
import { SvppMainComponent } from './svpp/svpp-main/svpp-main.component';
import { UploadDialogComponent } from './svpp/upload-dialog/upload-dialog.component';
import { DashboardComponent } from './ctp/dashboard/dashboard.component';
import { RentalEvComponent } from './admin/rental-ev/rental-ev.component';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'user_role',
        loadChildren: () => import('./user-role/user_role.module').then(m => m.UserRoleModule),
      },
      {
        path: 'rental_ev',
        component: RentalEvComponent,
      },
      {
        path: 'report',
        loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
      },
      {
        path: 'vcm',
        loadChildren: () => import('./vcm/vcm.module').then(m => m.VcmModule),
      },
      {
        path: 'svpp',
        loadChildren: () => import('./svpp/svpp.module').then(m => m.SVPPModule),
      },
      {
        path: 'svppv2',
        component: SvppMainComponent,    
        loadChildren: () => import('./svpp/svpp.module').then(m => m.SVPPModule),
      },
      {
        path: 'upload',
        component: UploadDialogComponent,
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
      },
      {
        path: 'error',
        component: ErrorPageComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule { }
